import Vue from 'vue'
import VueResource from 'vue-resource'
// import partnersjson from '@/assets/resources/partners.js'

Vue.use(VueResource);

const development = false;

export default {
    requestPartners: (context) => {
        if(development) {
            context.commit("setPartners", partnersjson);
        } else {
            Vue.http.get('https://eo9-backend.firebaseapp.com/api/test-domain').then(
            response => {
                context.commit("setPartners", response.data);
            },
            error => {
                console.log(error);
                context.commit("setPartners", partnersjson);
            })
        }
    }
}